import { IGrades, IPricing, ISubjectsPricing } from '@wot/typings';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import pricingApi, { PricingReqBody } from '../../../api/pricing';
import { Button } from '@wot/components';

export function SubjectPricing() {
  const [pricing, setPricing] = useState<IPricing<ISubjectsPricing>>({
    _id: '',
    type: 'subject',
    pricing: {
      grades: {
        'Grade I': {
          standard: 0,
          premium: 0
        },
        'Grade II': {
          standard: 0,
          premium: 0
        },
        'Grade III': {
          premium: 0,
          standard: 0
        },
        'Grade IV': {
          standard: 0,
          premium: 0
        },
        'Grade V': {
          standard: 0,
          premium: 0
        },
        'Grade VI': {
          premium: 0,
          standard: 0
        },
        'Grade VII': {
          premium: 0,
          standard: 0
        },
        'Grade VIII': {
          standard: 0,
          premium: 0
        },
        'Grade IX': {
          standard: 0,
          premium: 0
        },
        'Grade X': {
          premium: 0,
          standard: 0
        },
        'Grade XI': {
          premium: 0,
          standard: 0
        },
        'Grade XII': {
          premium: 0,
          standard: 0
        },
        'College Level': {
          premium: 0,
          standard: 0
        }
      }
    },
    createdAt: '',
    updatedAt: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (type: IGrades, newValues: any) => {
    if (pricing && pricing.pricing.grades) {
      setPricing({
        ...pricing,
        pricing: {
          ...pricing.pricing,
          grades: {
            ...pricing.pricing.grades,
            [type]: {
              ...pricing.pricing.grades[type],
              ...newValues
            }
          }
        }
      });
    }
  };

  const savePricing = () => {
    let data: PricingReqBody = {
      pricing: pricing.pricing,
      type: 'subject'
    };
    if (pricing._id) {
      setLoading(true);
      pricingApi
        .updatePricing(pricing)
        .then(() => {
          setLoading(false);
          toast.success('Subjects Pricing updated successfully!');
        })
        .catch(() => {
          setLoading(false);
          toast.error('Something went wrong.');
        });
    } else {
      setLoading(true);
      pricingApi
        .savePricing(data)
        .then((data) => {
          if (data) {
            setLoading(false);
            setPricing(data);
            toast.success('Subjects Pricing added successfully!');
          } else {
            setLoading(false);
            toast.error('Something went wrong.');
          }
        })
        .catch(() => {
          setLoading(false);
          toast.error('Something went wrong.');
        });
    }
  };

  useEffect(() => {
    pricingApi.getPricing('subject').then((data) => {
      if (data && data._id) {
        setPricing(data);
      }
    });
  }, []);

  return (
    <div className="w-full flex flex-col ">
      <div className="flex flex-col py-5 px-2">
        <table className="min-w-full table-auto">
          <thead className="bg-neutralBlue2">
            <th className="text-left py-2">
              <h1 className="text-sm font-medium uppercase mx-4">Grades</h1>
            </th>
            <th className="text-left py-2">
              <h1 className="text-sm font-medium uppercase">Standard</h1>
            </th>
            <th className="text-left py-2">
              <h1 className="text-sm font-medium uppercase">Premium</h1>
            </th>
          </thead>
          <tbody>
               {pricing &&
              pricing.pricing.grades &&
              Object.keys(pricing.pricing.grades).map((item, index) => (
                <tr key={index}>
                  {/* @ts-ignore */}
                  <Item
                    key={index}
                    grade={item} //@ts-ignore
                    standard={pricing.pricing.grades[item].standard} //@ts-ignore
                    premium={pricing.pricing.grades[item].premium}
                    handleChange={handleChange}
                  />
                </tr>
              ))}
          </tbody>
        </table>

        <div className="w-full bg-white py-10">
          <div className="max-w-[164px] w-full mx-auto flex gap-4 items-center justify-center">
            {/* <Button block type="s-outlined" text={'Cancel'} onClick={() => { }} /> */}
            <Button block loading={loading} text={'Save'} onClick={() => savePricing()} />
          </div>
        </div>
      </div>
    </div>
  );
}

export function Item({
  grade,
  standard,
  premium,
  handleChange
}: {
  grade: string;
  standard: number;
  premium: number;
  handleChange: any;
}) {
  return (
    <>
      <td className="text-left py-2">
        <div className="w-full max-w-[128px] px-4 py-2 border rounded-md">
          <h1 className="text-sm capitalize">{grade}</h1>
        </div>
      </td>
      <td className="text-left py-2">
        <div className="w-full  max-w-[128px] px-4 py-2 border rounded-md flex gap-2">
          <h3 className="text-sm">INR</h3>
          <input
            type="number"
            defaultValue={standard}
            value={standard}
            onChange={(e) => handleChange(grade, { standard: e.target.value })}
            className="w-full text-sm border-none outline-none bg-none"
          />
        </div>
      </td>
      <td className="text-left py-2">
        <div className="w-full max-w-[128px] px-4 py-2 border rounded-md flex gap-2">
          <h3 className="text-sm">INR</h3>
          <input
            type="number"
            defaultValue={premium}
            value={premium}
            onChange={(e) => handleChange(grade, { premium: e.target.value })}
            className="w-full  text-sm border-none outline-none bg-none"
          />
        </div>
      </td>
    </>
  );
}
